<template>
<form @submit.prevent="emitSave" id="insurerAddEditDialogForm">
  <h4 class="mb-4">{{ 'ADD' | translate }}</h4>

  <div class="form-group" id="insurerAddEditDialog-FormGroup-Maatschappij">
    <label>{{ 'Maatschappij' | translate }} <span class="asterisk">*</span></label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="insurer.name"
           required
           id="insurerAddEditDialog-Maatschappij-input">
  </div>

  <div class="form-group" id="insurerAddEditDialog-FormGroup-Description">
    <label>{{ 'Description' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="insurer.description"
           id="insurerAddEditDialog-Description-input">
  </div>

  <div class="form-group" id="insurerAddEditDialog-FormGroup-goid">
    <label>{{ 'goid' | translate }}</label>
    <input type="number"
           min="0"
           step="1"
           class="form-control form-control-sm"
           v-model="insurer.goid"
           id="insurerAddEditDialog-goid-input">
  </div>

  <div class="form-group" id="insurerAddEditDialog-FormGroup-oid">
    <label>{{ 'oid' | translate }}</label>
    <input type="number"
           min="0"
           step="1"
           class="form-control form-control-sm"
           v-model="insurer.oid"
           id="insurerAddEditDialog-oid-input">
  </div>
  <div class="form-group" id="insurerAddEditDialog-FormGroup-backoffciecodeincoming">
    <label>{{ 'BACKOFFICE_CODE_INCOMING' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="insurer.backofficeCodeIncoming"
           id="insurerAddEditDialog-oid-input">
  </div>
  <div class="form-group" id="insurerAddEditDialog-FormGroup-backofficecodeoutgoing">
    <label>{{ 'BACKOFFICE_CODE_OUTGOING' | translate }}</label>
    <input type="text"
           class="form-control form-control-sm"
           v-model="insurer.backofficeCodeOutgoing"
           id="insurerAddEditDialog-oid-input">
  </div>

  <div class="form-group" id="insurerAddEditDialog-FormGroup-enabled">
    <label>{{ 'Enabled' | translate }}</label>
    <input type="checkbox"
           class="form-control form-control-sm"
           v-model="insurer.enabled"
           id="insurerAddEditDialog-enabled-input">
  </div>

  <div class="mt-4 text-right" id="insurerAddEditDialog-FormGroup-buttons">

    <button class="btn btn-link" type="button"
            @click="emitClose"
            id="insurerAddEditDialog-FormGroup-closeButton"
    >{{ 'CLOSE' | translate }}</button>

    <button class="btn btn-primary"
            type="submit"
            :disabled="!isFormValid"
            id="insurerAddEditDialog-FormGroup-addButton"
    >{{ 'ADD' | translate }}</button>

  </div>
</form>
</template>

<script>
export default {
  props: [ 'edited' ],
  data() {
    return {
      insurer: {}
    }
  },
  computed: {
    isFormValid() {
      return this.insurer.name;
    }
  },
  methods: {
    emitSave() {
      this.$emit(this.edited ? 'update' : 'save', this.insurer);
      this.insurer = {};
    },
    emitClose() {
      this.$emit('close');
      this.insurer = {};
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.insurer = {...newVal};
    }
  }
}
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/insurer/InsurerAddEditDialog.vue